export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const USER_LOADED = "USER_LOADED";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAIL = "CREATE_USER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const AUTH_ERROR = "AUTH_ERROR";
export const GET_USERS = "GET_USERS";
export const GET_USERS_ERROR = "GET_USERS_ERROR";
export const LOGOUT = "LOGOUT";
export const GET_TICKETS = "GET_TICKETS";
export const GET_TICKETS_ERROR = "GET_TICKETS_ERROR";
export const CREATE_TICKET_SUCCESS = "CREATE_TICKET_SUCCESS";
export const CREATE_TICKET_FAIL = "CREATE_TICKET_FAIL";
export const PUT_EDIT_PROFILE = "PUT_EDIT_PROFILE";
export const PUT_EDIT_PROFILE_ERROR = "PUT_EDIT_PROFILE_ERROR";
export const GET_TICKET = "GET_TICKET";
export const TICKET_ERROR = "TICKET_ERROR";
export const ADD_REPLY = "ADD_REPLY";
export const UPDATE_TICKET_STATUS = "UPDATE_TICKET_STATUS";
export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_ERROR = "DELETE_USER_ERROR";
export const RESET_SUCCESS = "RESET_SUCCESS";
export const RESET_FAIL = "RESET_FAIL";
export const NEW_PASS_SUCCESS = "NEW_PASS_SUCCESS";
export const NEW_PASS_FAIL = "NEW_PASS_FAIL";
